import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { IGetBriefInfluencerV2Response } from "@shared/lib/types/briefInfluencerV2";
import { makeBriefInfluencerV2QueryKey } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useGetBriefInfluencerV2(influencerId: string) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IGetBriefInfluencerV2Response>
  >({
    queryKey: makeBriefInfluencerV2QueryKey(influencerId),
    queryFn: () => BriefService.getBriefInfluencerV2(influencerId),
    enabled: !!influencerId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefInfluencer: data?.data,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
